import React from 'react';
import { LinearProgress } from '@mui/material';
import { Alert } from '../../app/alert/alert';

interface WarningAlertProps {
    message: string;
    loading: boolean;
    progress?: number;
}

export const WarningAlert: React.FC<WarningAlertProps> = ({ message, loading, progress }) => {
    return (
        <Alert type="warning" icon loading={loading}>
            {message}
            {progress !== undefined ? <LinearProgress variant="determinate" value={progress} /> : null}
        </Alert>
    );
};
